/**
 * A component labels an entity as possessing a particular aspect, and holds the data needed to model that aspect.
 * For example, every game object that can take damage might have a Health component associated with its entity.
 */
export class Component {
  constructor(...args: unknown[]) {}
}
